var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container category-page" },
    [
      _c("block-breadcrumbs"),
      _c("banners-slot", {
        staticClass: "bottom-offset",
        attrs: { "slot-name": "transparency_subcategory" }
      }),
      _c("page-head", {
        attrs: { title: _vm.SEO.head || _vm.CATEGORY_NAME, info: _vm.subtitle }
      }),
      _c(
        "div",
        { staticClass: "body" },
        [
          _c("side-nav"),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("filters"),
              _vm.PRODUCTS.length
                ? [_c("products-list")]
                : _c(
                    "page-info",
                    { attrs: { title: "Товары не найдены" } },
                    [_c("no-delivery-warning")],
                    1
                  )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }